@tailwind base;
@tailwind components;
@tailwind utilities;

h1,
h2,
h3,
h4,
h5,
p,
span,
a {
  line-height: 120%;
}

/* RICH TEXT EDITOR */
.amp-rte-container > * {
  @apply text-dark;
}

.amp-rte-container :first-child {
  @apply mt-0;
}

.amp-rte-container h2,
.amp-rte-container h3,
.amp-rte-container h4 {
  @apply font-semibold mt-4;
}

.amp-rte-container h2 {
  @apply text-2xl;
}

.amp-rte-container h3 {
  @apply text-lg;
}

.amp-rte-container h4 {
  @apply text-base;
}

.amp-rte-container strong {
  @apply font-bold;
}

.amp-rte-container span {
  @apply overflow-hidden;
}

.amp-rte-container a,
.amp-rte-container p > a {
  @apply text-primary font-semibold;
}

.amp-rte-container a,
.amp-rte-container p > a {
  @apply hover:underline;
}

.amp-rte-container p {
  @apply leading-[1.4] max-w-[945px];
}

.amp-rte-container blockquote {
  @apply mb-2;
}

.amp-rte-container blockquote > p {
  @apply italic border-l border-borderDefault pl-4 mr-4;
}

.amp-rte-container img {
  @apply w-full h-full max-h-[350px] object-contain object-left;
}

.amp-rte-container ul {
  column-count: auto;
  column-width: 25ch;
  @apply gap-x-16 pl-6;
}

.amp-rte-container ul > li {
  @apply list-disc mb-2;
}

.amp-rte-container ol {
  column-count: auto;
  column-width: 25ch;
  @apply gap-x-16 pl-8;
}

.amp-rte-container ol > li {
  @apply list-decimal	mb-2;
}

.amp-rte-container thead tr {
  @apply border-b border-borderDefault;
}

.amp-rte-container thead tr th {
  @apply font-semibold p-3;
}

.amp-rte-container thead tr th strong {
  @apply font-semibold;
}

.amp-rte-container tbody tr {
  @apply border-b border-borderDefault;
}

.amp-rte-container tbody td {
  @apply p-3 border-x border-borderDefault;
}

.amp-rte-container th,
.amp-rte-container td {
  @apply min-w-[100px];
}

@media (min-width: 768px) {
  .amp-rte-container blockquote {
    @apply mb-4 ml-16;
  }

  .amp-rte-container blockquote > p {
    @apply text-lg;
  }

  .amp-rte-container img {
    @apply py-0 px-4;
  }
}

/* LOADING SPINNER */
.fg-icon-loader {
  display: none;
  width: 24px;
  height: 24px;
}

.loader-ferg-use,
.loader-ferg {
  width: 100px;
  height: 100px;
  overflow: visible;
}

.loader-logo {
  transform-origin: 50% 50%;
  animation-name: spinner-logoscale;
  animation-duration: 1350ms;
  animation-timing-function: linear;
  animation-iteration-count: 1;
  fill: currentColor;
}

.loader-ferg .curve {
  transform: translate(0, 0);
  transform-origin: 50% 50%;
  animation-duration: 1000ms;
  animation-timing-function: ease-out;
  animation-delay: 200ms;
  animation-iteration-count: 1;
  animation-fill-mode: forwards;
}

.loader-ferg .curve-1 > path,
.loader-ferg .curve-2 > path,
.loader-ferg .curve-3 > path,
.loader-ferg .curve-4 > path {
  transform-origin: 50% 50%;
  animation-duration: 350ms;
  animation-timing-function: ease-out;
  animation-delay: 400ms;
  animation-iteration-count: 1;
  animation-fill-mode: forwards;
}

.loader-ferg .curve-1 {
  animation-name: spinner-curve, spinner-curve1;
}

.loader-ferg .curve-1 > path {
  transform-origin: 50% 50%;
  animation-name: spinner-curve1rotate;
  animation-timing-function: cubic-bezier(0.1, 0.97, 0.52, 1.83);
}

.loader-ferg .curve-2 {
  animation-name: spinner-curve, spinner-curve2;
}

.loader-ferg .curve-2 > path {
  transform-origin: 74% 27%;
  animation-name: spinner-curve2rotate;
}

.loader-ferg .curve-3 {
  animation-name: spinner-curve, spinner-curve3;
}

.loader-ferg .curve-3 > path {
  transform-origin: 50% 50%;
  animation-name: spinner-curve3rotate;
  animation-timing-function: cubic-bezier(0.1, 0.97, 0.52, 1.83);
}

.loader-ferg .curve-4 {
  transform-origin: 50% 50%;
  animation-name: spinner-curve, spinner-curve4;
}

.loader-ferg .curve-4 > path {
  transform-origin: 25% 75%;
  animation-name: spinner-curve4rotate;
}

.loader-circle {
  transform-origin: 50% 50%;
  opacity: 0;
  animation-name: spinner-circle;
  animation-duration: 1350ms;
  animation-timing-function: linear;
  animation-delay: 800ms;
  animation-iteration-count: infinite;
}

.loader-circle > circle {
  transform: rotate(0deg);
  -webkit-transform-origin: center;
  -ms-transform-origin: center;
  transform-origin: center;
  animation-name: spinner-reset, spinner-circleinner;
  animation-duration: 1450ms, 1350ms;
  animation-timing-function: ease-in-out;
  animation-delay: 700ms, 2150ms;
  animation-iteration-count: 1, infinite;
  stroke: #00446a;
  stroke: currentColor;
  stroke-linecap: round;
  stroke-dasharray: 185;
  stroke-dashoffset: 0;
}

@keyframes spinner-logoscale {
  0%,
  15% {
    transform: scale(1);
  }

  25% {
    transform: scale(0.8);
  }

  40% {
    transform: scale(0.1);
  }

  55%,
  100% {
    transform: scale(1);
  }
}

@keyframes spinner-curve1 {
  0% {
    transform: translate(0%, 0%);
  }

  15%,
  20% {
    transform: translate(10%, 10%);
  }

  35% {
    transform: translate(calc(16% * -1), calc(16% * -1));
  }

  60%,
  100% {
    transform: translate(calc(3% * -1), calc(3% * -1));
  }

  63% {
    opacity: 1;
  }

  64%,
  100% {
    opacity: 0;
  }
}

@keyframes spinner-curve2 {
  0% {
    transform: translate(0%, 0%);
  }

  15%,
  20% {
    transform: translate(-10%, 10%);
  }

  35% {
    transform: translate(16%, -16%);
  }

  60%,
  100% {
    transform: translate(3%, -3%);
  }

  63% {
    opacity: 1;
  }

  64%,
  100% {
    opacity: 0;
  }
}

@keyframes spinner-curve3 {
  0% {
    transform: translate(0%, 0%);
  }

  15%,
  20% {
    transform: translate(-10%, -10%);
  }

  35% {
    transform: translate(16%, 16%);
  }

  60%,
  100% {
    transform: translate(3%, 3%);
  }

  63% {
    opacity: 1;
  }

  64%,
  100% {
    opacity: 0;
  }
}

@keyframes spinner-curve4 {
  0% {
    transform: translate(0%, 0%);
  }

  15%,
  20% {
    transform: translate(10%, -10%);
  }

  35% {
    transform: translate(-16%, 16%);
  }

  60%,
  100% {
    transform: translate(-3%, 3%);
  }

  63% {
    opacity: 1;
  }

  64%,
  100% {
    opacity: 0;
  }
}

@keyframes spinner-curve1rotate {
  0% {
    transform: translate(0, 0);
  }

  100% {
    transform: translate(4.3%, 2.9%);
  }
}

@keyframes spinner-curve2rotate {
  0% {
    transform: rotate(0deg) translate(0, 0);
  }

  100% {
    transform: rotate(-90deg) translate(-2.7%, -2.1%);
  }
}

@keyframes spinner-curve3rotate {
  0% {
    transform: translate(0, 0);
  }

  100% {
    transform: translate(-3.6%, -4.4%);
  }
}

@keyframes spinner-curve4rotate {
  0% {
    transform: rotate(0deg), translate(0, 0);
  }

  100% {
    transform: rotate(-90deg) translate(4.4%, 3.6%);
  }
}

@keyframes spinner-reset {
  0%,
  100% {
    opacity: 1;
  }

  0% {
    stroke-dashoffset: 45;
    transform: rotate(-90deg);
  }

  50% {
    stroke-dashoffset: 140;
  }

  100% {
    stroke-dashoffset: 180;
    transform: rotate(810deg);
  }
}

@keyframes spinner-circle {
  0%,
  100% {
    opacity: 1;
  }

  0% {
    transform: rotate(0deg);
  }

  100% {
    transform: rotate(270deg);
  }
}

@keyframes spinner-circleinner {
  0%,
  100% {
    opacity: 1;
  }

  0% {
    stroke-dashoffset: 180;
  }

  50% {
    stroke-dashoffset: 80;
    transform: rotate(135deg);
  }

  100% {
    stroke-dashoffset: 180;
    transform: rotate(450deg);
  }
}
